import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import {
    DemoLoginComponent,
    ForgotPasswordComponent,
    LoginComponent,
    SignupComponent
} from './components';

const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login/:returnUrl', data: { title: 'Login' }, component: LoginComponent },
    { path: 'login', data: { title: 'Login' }, component: LoginComponent },
    { path: 'demo-login/:returnUrl', data: { title: 'Demo Login' }, component: DemoLoginComponent },
    { path: 'demo-login', data: { title: 'Login' }, component: DemoLoginComponent },
    { path: 'sign-up/:token/:user/:otp', data: { title: 'SignUp' }, component: SignupComponent },
    { path: 'sign-up', data: { title: 'SignUp' }, component: SignupComponent },
    { path: 'reset-password/:token/:user/:otp', data: { title: 'Forgot Password' }, component: ForgotPasswordComponent },
    { path: 'reset-password/:token/:user', data: { title: 'Setup Password' }, component: ForgotPasswordComponent },
    { path: 'forgot-password', data: { title: 'Forgot Password' }, component: ForgotPasswordComponent },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AuthRoutingModule { }